export default "__VITE_ASSET__Co0wf_DR__"